import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import {
  PortfolioSummaryViewModel,
  ClientDetailsGetPortfolioSummaryRequest,
  ResultOfPortfolioSummaryViewModel
} from 'bff/client';

export const useInvalidateInvestments = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: ['investmentBreakdown'],
      refetchType: 'all'
    });
};

export const useInvestmentBreakdownQuery = (
  request: ClientDetailsGetPortfolioSummaryRequest,
  isEnabled: boolean
): UseQueryResult<PortfolioSummaryViewModel | undefined, Error> => {
  const { clientDetailsApi } = useApiClient();

  return useQuery<ResultOfPortfolioSummaryViewModel, Error, PortfolioSummaryViewModel | undefined>({
    queryKey: ['investmentBreakdown', request.clientId],
    queryFn: () => clientDetailsApi.clientDetailsGetPortfolioSummary(request),
    select: (response) => response.data,
    enabled: isEnabled
  });
};
